import angular from 'angular';

function modalWindowBody($compile, $http, $templateCache, $q) {

  function getBodyTemplate(modal) {

    if (modal.component) {
      const componentTemplateName =
        modal.component.replace(
          /[A-Z]/g, (letter, pos) => (pos ? '-' : '') + letter.toLowerCase()
        );

      let content = document.createElement(componentTemplateName);
      content = angular.element(content);
      content.attr({
        resolve: 'resolve',
        'set-on-submit': 'setOnSubmit',
        'enable-submit': 'enableSubmit',
        'disable-submit': 'disableSubmit'
      });
      return $q.when(content[0].outerHTML);
    } else if (modal.template) {
      return $q.when(modal.template);
    } else {
      return $http.get(modal.templateUrl, {cache: $templateCache})
        .then(result => result.data);
    }
  }

  return {
    restrict: 'E',
    replace: true,
    template: `<div class="modal-body" ng-class="{'processing': modalWindow.processing}">
                   <div class="backwash"></div>
               </div>`,
    link(scope, element) {
      getBodyTemplate(scope.modalWindow.templateModel)
        .then(content => element.append($compile(content)(scope.modalWindow.contentScope)));
    }
  };
}

modalWindowBody.$inject = ['$compile', '$http', '$templateCache', '$q'];

export default modalWindowBody;
